import * as fromPl from './pl.reducer';
import * as fromPlColumn from './pl-column.reducer';
import { Action, combineReducers } from '@ngrx/store';
import { PlState, PlColumnState } from '../pl.types';

export interface RouteState {
  api: PlState;
  apiColumn: PlColumnState;
}

export interface State {
  pl: RouteState;
}

export function reducers(
  state: RouteState | undefined,
  action: Action
): RouteState {
  return combineReducers({
    api: fromPl.reducer,
    apiColumn: fromPlColumn.reducer,
  })(state, action);
}

export { fromPl };
